import { scrollTo } from '@/utils/html';
import React, { useRef, useEffect, useContext, PropsWithChildren } from 'react';
import { setCanScroll } from '@/state/global/actions';
import { useAppDispatch } from '@/utils/hooks';
import { StickyContext } from '@ygtechnologies/bygr-frontend-component-library';
interface ScrollToWrapperProps extends PropsWithChildren {
    shouldScroll?: boolean;
}

const getOffset = (element: Element | null, currentOffset: number) => {
    if (!element) return currentOffset;
    var htmlElement: HTMLElement = element as HTMLElement;
    currentOffset += htmlElement.offsetTop;
    return getOffset(htmlElement.offsetParent, currentOffset);
};

const ScrollToWrapper: React.FC<ScrollToWrapperProps> = ({ shouldScroll = false, children }) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const dispatch = useAppDispatch();

    const stickyContext = useContext(StickyContext);

    useEffect(() => {
        if (shouldScroll && containerRef.current) {
            dispatch(setCanScroll(false));
            scrollTo(0, getOffset(containerRef.current, 0) - stickyContext.currentOffset - 55);
        }
    }, [containerRef, shouldScroll, stickyContext, dispatch]);

    return <div ref={containerRef}>{children}</div>;
};

export default ScrollToWrapper;
